import React from 'react'
import styled from 'styled-components'
import {FaPlus} from 'react-icons/fa'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import Pagination from "./Pagination";
import Store from '../../Common/Store.js';
import {IoMdAddCircle } from "react-icons/io";

import "./table_styles.css";

const MRButton = styled.button`
    display: inline-block;
    box-sizing: border-box;
    background-color: #223B5A;
    color: #ffffff;
    width: 160px;
    height: 35px;
    border-radius: 4px;
    border: 1px solid #37ada7;
    margin-left: 5px;
    font-size: 11px;
    padding-left: 12px;
    cursor: pointer;
`;
const HeaderText = styled.div`
    padding: 5px
    margin-top: 10px;
    margin-bottom: 10px;
    color: #fff;
    font-weight: 600;
    letter-spacing: 1px;
    background-color: #4472c4;
`;
const TableHeaderIcon = styled.div`
    margin-right: 10px;
    margin-top: -25px;
    margin-bottom: 10px;
    color: #4472c4;
    font-weight: 600;
    float: right;
    letter-spacing: 1px;
`;

const TextPara = styled.div`
    padding: 15px 15px 15px 15px;
    color: #c0c0c0;
`
const TableContainer = styled.div`
    background-color: #ffffff;
`
const HeaderHr = styled.div`
    display: block;
    unicode-bidi: isolate;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    margin-inline-start: auto;
    margin-inline-end: auto;
    overflow: hidden;
    border-style: ridge;
    border-width: 1px;
`;
const ExportButton = styled.button`
    box-sizing: border-box;
    background-color: #213E61;
    color: #F2F2F2;
    border: 1px solid #213E61;
    width: 125px;
    font-size: 14px;
    height: 32px;
    border-radius: 5px;
    margin: 12px;
    cursor: pointer;
`;


class CSLTable extends React.Component
{
    constructor(props) {
        super(props);
    }



    filterMethod = (filter, row, column) => {
        const id = filter.pivotId || filter.id
        console.log('id',id);
        return row[id] !== undefined ? String(row[id]).includes(filter.value) : true
    }

    addsubTask = (event) => {
        event.preventDefault();
        this.props.addsubTask();
    }

    exportToCSV = () => (event) => {
        event.preventDefault();
        let fileName = "export";
        if('export_file_name' in this.props) {
            fileName = this.props.export_file_name;
        }
        let tableData = this.props.processData();
        let headerCSV = this.props.prefered_columns;
        console.log("headerCSV",headerCSV)
        let data= tableData.data;
        let columns= tableData.columns;
        let csv_data_arr = [];

        csv_data_arr.unshift(headerCSV);
        for(let k = 0; k < data.length; k++) {
            let cont = {};

            Object.entries(headerCSV).forEach(([key, value]) => {
                console.log("data[k][key]",data[k][key])
                    cont[key] = data[k][key].replace(/,/g, ' ').replace(/--/g, ' ').replace(/[\r\n]+/g," ");
            })
            csv_data_arr.push(cont);
        }
        console.log("csv_data_arr",csv_data_arr)
        var csv_data_final_arr = [];
        for(let j = 0; j<  csv_data_arr.length; j++){
          var container = [];
          container = Object.values(csv_data_arr[j])
          if(container.length > 0);
          csv_data_final_arr.push(container)
        }
        console.log("csv_data_final_arr",csv_data_final_arr)
        let csvContent = "data:text/csv;charset=utf-8," + csv_data_final_arr.map(e => e.join(",")).join("\n");
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", fileName + ".csv");
        document.body.appendChild(link);
        link.click();

    }


	render() {
		// console.log('this.props', this.props);
		let tableData = this.props.processData();
		console.log('tableData', tableData);
        let tableRows = this.props.tableRows ? this.props.tableRows : 5;
        let add_task_url ='/task/0';
		return (
			<TableContainer>
			    <HeaderText>
                {this.props.headerText}
                {
                    (() => {
                        if(this.props.subtask) {
                            return (<IoMdAddCircle style={{float:"right", color:"#f5f5fd", fontSize: "large", cursor: "pointer"}} onClick={this.addsubTask}/>)
                        }

                    })()
                }

                </HeaderText>
                <HeaderHr />
                {
                    (() => {
                        if (this.props.add) {
                            return (<a href={add_task_url}><MRButton title={this.props.addTitle}>Add New Task</MRButton></a>);
                        }
                    })()
                }
                <div style={{clear: "both"}}></div>
                    <div style={{marginTop: '5px', width:'100%'}}>
	                    <ReactTable
	                    	PaginationComponent={Pagination}
						    data={tableData.data}
						    columns={tableData.columns}
						    defaultPageSize={tableRows}
                            filterable={true}
                            defaultFilterMethod={(filter, row, column) => {
        const id = filter.pivotId || filter.id
        console.log('id',id);
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
    }}

						/>
					</div>
                    {
                        (() => {
                            if ('export' in this.props && this.props.export === true) {
                                return (<ExportButton  onClick={this.exportToCSV()}>Export</ExportButton>);
                            }
                        })()
                    }
			</TableContainer>
			);
	}
}

export default CSLTable;
